import { Component, OnDestroy, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter, take } from "rxjs";
import { AuthenticationService } from "./core/services/auth.service";
import { InactivityService } from "./core/services/inactivity.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(
    private authService: AuthenticationService,
    private inactivityService: InactivityService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // Aguarda a navegação inicial para garantir que router.url esteja correto
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        take(1)
      )
      .subscribe(() => {
        if (this.authService.getCurrentUser) {
          this.authService.getMe().subscribe({
            next: (user) => {
              if (user) {
                this.authService.saveCurrentUser(user);
                this.inactivityService.startMonitoring();
              }
            },
            error: () => {
              // Usuário não autenticado
            }
          });
        }
      });
  }

  private isOnAccountRoute(): boolean {
    return this.router.url.startsWith("/account");
  }

  ngOnDestroy(): void {
    // Para o monitoramento ao destruir o componente
    this.inactivityService.stopMonitoring();
  }
}
